module.exports = __webpack_public_path__ + "img/logo-pix.dcf0ed13.png";